'use es6';

import { StyledBorder } from '../atoms/DashedLabel';
import DateLabelMessage from '../dates/components/DateLabelMessage';
import { CIRRUS } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyleWrapper = styled.div.withConfig({
  displayName: "DateLabel__StyleWrapper",
  componentId: "sc-1dmjbda-0"
})(["", "{border-color:", ";}"], StyledBorder, CIRRUS);
const DateLabel = props => {
  return /*#__PURE__*/_jsx(StyleWrapper, {
    children: /*#__PURE__*/_jsx(DateLabelMessage, Object.assign({}, props, {
      labelPadding: "m-y-3"
    }))
  });
};
DateLabel.displayName = 'DateLabel';
DateLabel.propTypes = DateLabelMessage.propTypes;
export default DateLabel;